import { ChevronDownIcon, ChevronRightIcon, XIcon } from "@heroicons/react/outline";
import { observer } from "mobx-react-lite";

import { useSchemaEditor } from "..";

import { SchemaParameterContent } from "./SchemaParameterContent";
import { ISchemaParameter } from "./schema-parameter-store";

import { Button } from "@/components/ui/button";

interface SchemaParameterProps {
  parameter: ISchemaParameter;
}

const SchemaParameter = observer(({ parameter }: SchemaParameterProps) => {
  const schemaEditor = useSchemaEditor();
  const { isReadonly } = schemaEditor;

  const indentStyle = {
    marginLeft: `${parameter.depth * 6}px`,
    position: "relative" as const,
  };

  const handleToggleCollapsed = (e: React.MouseEvent) => {
    e.stopPropagation();
    parameter.toggleCollapsed();
  };

  return (
    <div
      className={`relative flex min-w-[450px] flex-col gap-y-2  ${
        parameter.isChild ? " pl-4" : ""
      }`}
      style={{
        ...indentStyle,
      }}
    >
      <div
        className={`flex cursor-pointer select-none flex-row items-center justify-between gap-x-2 border-b   ${
          parameter.isParent ? "px-2 py-2" : ""
        } transition-colors hover:bg-gray-50`}
        onClick={handleToggleCollapsed}
      >
        <div className="flex items-center">
          <button
            onClick={handleToggleCollapsed}
            className="mr-2 rounded p-1 focus:outline-none focus:ring-2 focus:ring-blue-300"
          >
            {parameter.isExpanded ? (
              <ChevronDownIcon className="h-4 w-4" />
            ) : (
              <ChevronRightIcon className="h-4 w-4" />
            )}
          </button>
          <span
            className={`cursor-pointer text-sm text-gray-700 ${
              parameter.isParent ? "text-sm" : "text-xs"
            }`}
            onClick={handleToggleCollapsed}
          >
            {parameter.name || (parameter.isParent ? `Untitled Parameter` : `Untitled Field`)}
          </span>
        </div>
        {!isReadonly && (
          <Button
            variant="destructiveLink"
            size="tinyIcon"
            onClick={e => {
              e.stopPropagation();
              schemaEditor.deleteParameter(parameter);
            }}
            className="focus:outline-none focus:ring-2 focus:ring-red-300"
          >
            <XIcon className="h-4 w-4" />
          </Button>
        )}
      </div>
      <SchemaParameterContent parameter={parameter} />
    </div>
  );
});

export default SchemaParameter;
